import React from 'react'
import LeadError from '../LeadError'
import { ReactComponent as User } from 'assets/svg/user.svg'
import { ReactComponent as Users } from 'assets/svg/users.svg'

export default function LeadPayer(props) {
  const { data, setData, errors, setErrors, reloadExperiments, posthog, setHighestLandedStep } = props

  const handlePayerChange = (payer) => {
    setErrors(false)
    setHighestLandedStep(0)
    setData(prev => ({
      ...prev,
      payer,
      occasion: undefined,
    }))

    // Set person attribute based on payer selection
    if (payer === 'attendee') {
      posthog.setPersonPropertiesForFlags({ eligible_for_loco_lead_form_vending: true }, true)
    } else {
      posthog.setPersonPropertiesForFlags({ eligible_for_loco_lead_form_vending: false }, true)
    }
    // Reload experiment assignment for the specific feature flag
    reloadExperiments()
  }

  return (
    <div>
      <div className="p-8">
        <div className="flex text-gray-400">
          <Option
            icon={<User className="h-6" />}
            title={"Catering"}
            text={"One person pays for everyone"}
            data-test-id='payer-host'
            active={data.payer === 'host'}
            onClick={() => handlePayerChange('host')}
          />
          <Option
            icon={<Users className="h-6" />}
            title={"Vending"}
            text={"Eaters pay at the event"}
            data-test-id='payer-attendee'
            className="border-l-0"
            active={data.payer === 'attendee'}
            onClick={() => handlePayerChange('attendee')}
          />
        </div>
        {errors?.payer && (
          <LeadError
            message={errors.payer}
            className="text-center"
          />
        )}
      </div>
    </div>
  )
}

function Option({ icon, title, text, active, className, ...rest }) {

  return (
    <div
      {...rest}
      className={[
        'cursor-pointer w-1/2 border border-gray-300 p-6 flex flex-col items-center',
        active && 'bg-white text-blue border-gray-400',
        className
      ]}
    >
      {icon}
      <div>
        <p className={['text-lg font-light text-center text-gray-800', active && 'text-black']}>
          {title}
        </p>
        
        {text ? (
          <p className={['text-sm font-light text-center text-gray-800', active && 'text-black']}>
            {text}
          </p>
        ) : null}
      </div>
    </div>
  )
}
